import React, { useState, useContext, useEffect } from 'react';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import Button from "app/components/CustomButtons/Button.js";
import axios from 'axios';
import FormCOL from "./FormCOL.js";
import FormCO from "./FormCO.js";
import { Redirect } from 'react-router';
import $ from 'jquery';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { darkBlueColor } from 'app/layout/material-dashboard-react.js';
import { LoginStatusContext } from 'app/context/LoginStatusContext';

const urlCustomerOrder = `${process.env.REACT_APP_API_ENDPOINT}/api/customerOrder`;
const urlCustomerOrderLine = `${process.env.REACT_APP_API_ENDPOINT}/api/customerOrderLine`;

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
    buttonStyling: {
        backgroundColor: '#ee2e24',
        color: '#ffffff',
        width: '120px',
        padding: '5px',
        borderRadius: '5%'
    },
};

const useStyles = makeStyles(styles);

export default function CustomerOrderEdit() {
    const classes = useStyles();

    //usestate hooks - CO
    const [cOPostType, setCOPostType] = useState("add");
    const [showButtonContinueCO, setShowButtonContinueCO] = useState(true);
    const [showButtonEditCO, setShowButtonEditCO] = useState(false);
    const [disableInputCO, setDisableInputCO] = useState(false);
    const [customerOrderID, setCustomerOrderID] = useState(0);
    const [referenceID, setReferenceID] = useState("")
    const [contactName, setContactName] = useState("");
    const [requiredDate, setRequiredDate] = useState();
    const [customerReference, setCustomerReference] = useState("");
    const [dateAdded, setDateAdded] = useState();
    const [userAdded, setUserAdded] = useState("");
    const [accountID, setAccountID] = useState(0);
    const [customerSupplierID, setCustomerSupplierID] = useState(0);
    const [deliveryAddressID, setDeliveryAddressID] = useState(0);
    const [ediReference, setEdiReference] = useState("");
    const [sixDigitReference, setSixDigitReference] = useState("");
    const [bookingSlot, setBookingSlot] = useState(null);
    const [containerNumber, setContainerNumber] = useState("");
    const [sealNumber, setSealNumber] = useState("");
    const [bookingID, setBookingID] = useState("");

    //usestate hooks COL
    const [cOLPostType, setCOLPostType] = useState("add");
    const [showButtonSaveCOL, setShowButtonSaveCOL] = useState(true);
    const [showButtonDeleteCOL, setShowButtonDeleteCOL] = useState(false);
    const [showFormCOL, setShowFormCOL] = useState(false);
    const [customerOrderLineID, setCustomerOrderLineID] = useState('');

    const { setIsLoggedIn } = useContext(LoginStatusContext);
    
    useEffect(() => {
        async function validateUserSessionId() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/login/ValidateUserSessionId`)
                        .then(() => setIsLoggedIn(true));
                
            } catch (error) {
                setIsLoggedIn(false);
                window.location.replace(`${process.env.PUBLIC_URL}/login`);
            }
        }
        validateUserSessionId();
    }, [setIsLoggedIn]);

    //Determine Page and remove any old CO details
    if ('COD' in sessionStorage) {
        sessionStorage.removeItem('COD');

        //remove old CO details
        sessionStorage.removeItem("COAccountID");
        sessionStorage.removeItem("COCustomerSupplierID");
        sessionStorage.removeItem("CODContactName");
        sessionStorage.removeItem("CODCustomerReference");
        sessionStorage.removeItem("CODCustomerSupplierName");
        sessionStorage.removeItem("CODDeliveryAddressName");
        sessionStorage.removeItem("CODRequiredDate");
        sessionStorage.removeItem("CODeliveryAddressID");
    }

    function updateCO() {
        setCOPostType("update");
    }

    function deleteCOL() {
        setCOLPostType("delete");
        setCOPostType("delete");
    }

    function reset() {
        if (cOPostType === "delete") {
            window.location.reload(true); 
        }
    }
  
    function getIDs() {
        try {
            setAccountID(sessionStorage.getItem('COAccountID'));
            setCustomerSupplierID(sessionStorage.getItem('COCustomerSupplierID'));
            setDeliveryAddressID(sessionStorage.getItem('CODeliveryAddressID'));
        }
        catch {
            console.log("CO: There was an issue with setting the ids")
        }
    }

    const setRequiredDateFunction = (date) => {
        setRequiredDate(date);
    };

    const setBookingSlotFunction = (date) => {
        setBookingSlot(date);
    };

    const setBookingIdFunction = (bookingID) => {
        setBookingID(bookingID);
    };

    //form related
    const onSubmit = (e) => {
        e.preventDefault();

        const form = e.currentTarget;

        var formData = new FormData(form);
        formData.append("CustomerOrderPostType", cOPostType);
        formData.append("accountID", accountID);
        formData.append("customerSupplierID", customerSupplierID);
        formData.append("deliveryAddressID", deliveryAddressID);
        formData.append("COCustomerSupplierID", customerSupplierID);
        formData.append("requiredDate", requiredDate);
        formData.append("bookingSlot", bookingSlot);
        formData.append("bookingID", bookingID);

        if (cOPostType === "update") {
            formData.append("customerOrderID", customerOrderID);
            formData.append("ReferenceID", referenceID);
            formData.append("dateAdded", dateAdded);
            formData.append("userAdded", userAdded);
            formData.append("ediReference", ediReference);
            formData.append("sixDigitReference", sixDigitReference);
            formData.append("bookingSlot", bookingSlot);
            formData.append("containerNumber", containerNumber);
            formData.append("sealNumber", sealNumber);
        }

        if (cOPostType !== "add" && cOPostType !== "update") {
            formData.append("customerOrderID", customerOrderID);
            formData.append("CustomerOrderLinePostType", cOLPostType);
            formData.append("ReferenceID", referenceID);
            formData.append("CustomerOrderLineID", customerOrderLineID);
            formData.append("contactName", contactName);
            formData.append("requiredDate", requiredDate);
            formData.append("customerReference", customerReference);
            formData.append("dateAdded", dateAdded);
            formData.append("userAdded", userAdded);
            formData.append("ediReference", ediReference);
            formData.append("sixDigitReference", sixDigitReference);
            formData.append("bookingSlot", bookingSlot);
            formData.append("containerNumber", containerNumber);
            formData.append("sealNumber", sealNumber);
        }

        var plainFormData = Object.fromEntries(formData.entries());
        const formDataJsonString = JSON.stringify(plainFormData);

        //API
        TypeOfAPICall(cOPostType);

        function TypeOfAPICall(cOPostType) {

            if (cOPostType === "add" || cOPostType === "update" || cOPostType === "delete") {
                axios
                    .post(
                        urlCustomerOrder,
                        formDataJsonString
                    )
                    .then((response) => {
                        if (response !== null) {
                            if (response.status === 200) {
                                var variableInResponse = response.data.split(",");
                                if (variableInResponse.length === 15) {
                                    setReferenceID(variableInResponse[0]);
                                    setCustomerOrderID(Number(variableInResponse[1]));
                                    setAccountID(variableInResponse[2]);
                                    setCustomerSupplierID(variableInResponse[3]);
                                    setDeliveryAddressID(variableInResponse[4]);
                                    setContactName(variableInResponse[5]);
                                    setRequiredDate(variableInResponse[6]);
                                    setCustomerReference(variableInResponse[7]);
                                    setDateAdded(variableInResponse[8]);
                                    setUserAdded(variableInResponse[9]);
                                    setEdiReference(variableInResponse[10]);
                                    setSixDigitReference(variableInResponse[11]);
                                    setBookingSlot(variableInResponse[12]);
                                    setContainerNumber(variableInResponse[13]);
                                    setSealNumber(variableInResponse[14]);
                                    setShowButtonContinueCO(false);
                                    setShowButtonEditCO(true);
                                    setDisableInputCO(true);
                                    setShowFormCOL(true);
                                    setCOPostType("");
                                    setShowButtonDeleteCOL(true);
                                }
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log(error + " posting to Customer Order");
                    });
            }
            if (cOPostType !== "add") {
                if (cOPostType !== "update") {
                    if (cOPostType !== "delete") {
                        axios
                            .post(
                                urlCustomerOrderLine,
                                formDataJsonString
                            )
                            .then((response) => {
                                if (response !== null) {
                                    if (response.status === 200) {
                                        setCustomerOrderLineID(response.data);
                                        $("#sucess").show();
                                        $("#error").hide();

                                        setTimeout(() => {
                                            $("#sucess").hide();
                                        }, 5000)

                                        try {
                                            let hasCommas = response.data.includes(',');
                                            if (hasCommas) {
                                                var separatedStringArray = response.data.split(',');
                                                for (let i = 0; i < separatedStringArray.length; i++) {
                                                    if (separatedStringArray[i] !== '') {
                                                        formData.append("CustomerOrderLineID" + i, separatedStringArray[i])
                                                    }
                                                }
                                            }
                                        }
                                        catch {
                                            if (response.data !== '') {
                                                formData.append("CustomerOrderLineID" + 0, response.data)
                                            }
                                        }
                                        formData.append("CustomerOrderLineID", response.data);
                                        plainFormData = Object.fromEntries(formData.entries());
                                        setShowButtonSaveCOL(true);
                                        setShowButtonDeleteCOL(true);
                                    }
                                    else {
                                        $("#error").show();
                                        $("#sucess").hide();

                                        setTimeout(() => {
                                            $("#error").hide();
                                        }, 5000)
                                    }
                                }
                                else {
                                    $("#error").show();
                                    $("#sucess").hide();

                                    setTimeout(() => {
                                        $("#error").hide();
                                    }, 5000)
                                }
                                //delete pathway
                                if (cOLPostType === "delete") {
                                    reset();
                                }
                            })
                            .catch(function (error) {
                                console.log(error + " posting to Customer Order Line");
                            });
                    }
                }
            }
        }
    };

    return (
        <div id="CO">
            <form onSubmit={onSubmit}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader style={{ backgroundColor: darkBlueColor }}>
                                <h4 className={classes.cardTitleWhite}>Europa Customer Order {referenceID}</h4>
                            </CardHeader>
                            <CardBody>
                                <FormCO key={`form-col-$1`} disableInputCo={disableInputCO} setRequiredDateFunction={setRequiredDateFunction} setBookingSlotFunction={setBookingSlotFunction} setBookingIdFunction={setBookingIdFunction}  />
                            </CardBody>
                            <CardFooter>
                                {showButtonContinueCO && (<Button color="blue" input type="submit" onClick={getIDs}>Continue</Button>)}
                                {showButtonEditCO && (<Button color="blue" input type="submit" onClick={updateCO}>Save Edit</Button>)}
                            </CardFooter>
                        </Card>
                    </GridItem>
                </GridContainer>
            </form>

            {showFormCOL && (
                <form onSubmit={onSubmit} id="COL">
                    <GridContainer>
                        <GridItem xs={12} sm={12}>
                            <Card>
                                <CardHeader style={{ backgroundColor: '#2059A7' }}>
                                    <h4 className={classes.cardTitleWhite}>Europa Customer Order Form {referenceID}</h4>
                                </CardHeader>
                                <CardBody>
                                    <FormCOL />
                                </CardBody>
                                <GridItem xs={12} sm={12}>
                                    {showButtonSaveCOL && (<Button color="blue" input type="submit" className={classes.buttonLink} value="Save">Save</Button>)} &nbsp;
                                </GridItem>
                                <GridItem xs={12} sm={12}>
                                    &nbsp;
                                </GridItem>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </form>
            )}
            <GridContainer>
                <GridItem xs={12} sm={12}>
                    <Card>
                        <CardHeader>
                            &nbsp;
                        </CardHeader>
                        <GridItem xs={12} sm={12}>
                            <Button color="blue" className={classes.buttonLink} href="/LeoSeaPortal/createorder">New</Button> &nbsp;
                            {showButtonDeleteCOL && (<Button color="blue" input type="submit" form="COL" value="Delete" onClick={deleteCOL}>Delete</Button>)} &nbsp;
                        </GridItem>
                        <CardFooter>
                            <div id="sucess" style={{ display: "none" }}>
                                <Alert severity="success">
                                    <AlertTitle>Customer Order Saved</AlertTitle>
                                </Alert>
                            </div>
                            <div id="error" style={{ display: "none" }}>
                                <Alert severity="error">
                                    <AlertTitle>Error saving customer order</AlertTitle>
                                </Alert>
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}